import { get, patch } from 'utils/apiClient';

export async function getAll() {
  return get('notification');
}

export async function updateNotification(id) {
  return patch(`notification/${id}`);
}
